jQuery(document).ready(function () {
  $ = jQuery;

  if ($(".digest-container").length) {
    /* When a Filter for blog category is clicked */
    $(".blogs-filter .container button").click(function (event) {
      // Variables for current button
      var index = $(this).index(),
        tags = $(this).data("tags");

      if (tags == "All") {
        $(".blogs-filter .container").children().removeClass("active");
        $(".blog-card").each(function (index, el) {
          $(el).removeClass("noshow");
          $(el).addClass("show");
        });
      } else if ($(this).hasClass("active")) {
        makeInactive(index, tags);
      } else {
        $(".blogs-filter .container").children().removeClass("active");
        makeActive(index, tags);
      }
    });
    /* END when a Filter for blog category is clicked */

    function makeActive(index, tags) {
      var newthis = $(".blogs-filter .container").children()[index];
      $(newthis).addClass("active");
      // Now filter the product cards by all active tags
      filterProducts();
    }

    function makeInactive(index, tags) {
      var newthis = $(".blogs-filter .container").children()[index];
      $(newthis).removeClass("active");
      // Now filter the product cards by all active tags
      filterProducts();
    }

    function filterProducts() {
      //Variables for all buttons that have .active
      var activetags = [],
        activebtns = $(".blogs-filter .container").children(".active");

      $(activebtns).each(function (index, el) {
        var temp = $(this).data("tags");
        activetags.push(temp);
      });

      $(".blog-card").each(function (index, el) {
        var tags = $(this).data("tags");

        var allmatch = true;
        $(activetags).each(function (index, el) {
          // if all tags match activetags, show
          if (tags.includes(this)) {
            // this indicates a match, but don't change variables here
          } else {
            // don't show
            allmatch = false;
          }
        });

        if (allmatch == false) {
          $(el).removeClass("show");
          $(el).addClass("noshow");
        } else {
          $(el).removeClass("noshow");
          $(el).addClass("show");
        }
      });
    }
  }
});
